import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import { motion } from 'framer-motion';

export default function WalletCard(item) {
  const { altText, link, width, height, image, affiliation, name, platforms } = item;
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <motion.div
          className='group relative z-10 transform rounded-[14px] border border-[#303030] bg-[#061621] p-4 transition-colors duration-300 hover:border-[#404040] hover:shadow-lg hover:shadow-[#289fc633]'
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Link href={link} target='_blank' rel='noopener noreferrer' className='wallet-item block'>
            <div className='py-20'>
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              >
                <ExportedImage
                  placeholder='empty'
                  className='img-fluid mx-auto'
                  src={image}
                  alt={altText}
                  width={width}
                  height={height}
                />
              </motion.div>
            </div>
            <motion.div className='flex flex-col items-center border-t border-t-[#303030] p-5 py-7 transition-colors duration-300 group-hover:border-t-[#404040] lg:flex-row lg:justify-between'>
              <h5 className='wallet-title flex w-full flex-col -lg:flex-row -lg:items-center -lg:justify-between'>
                <motion.small
                  className='text-[#289fc6]'
                  whileHover={{ scale: 1.05, color: '#2ab0db' }}
                >
                  {affiliation}
                </motion.small>
                <p className='font-medium'>{name}</p>
              </h5>
              <div className='absolute right-4 top-4 flex w-full flex-row items-center justify-end gap-2'>
                {platforms.map((platform, index) => (
                  <motion.span
                    key={index}
                    className={`rounded-[14px] border border-[#5f61727d] bg-[#5a68e67d] p-1 px-3 text-[12px] ${platform
                      .toLowerCase()
                      .replace(' ', '-')}`}
                    whileHover={{
                      scale: 1.05,
                      backgroundColor: 'rgba(101, 116, 240, 0.6)',
                      borderColor: 'rgba(101, 116, 240, 0.5)',
                    }}
                    transition={{ type: 'spring', stiffness: 400, damping: 17 }}
                  >
                    {platform}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          </Link>
        </motion.div>
      </motion.div>
    </>
  );
}
